// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var PackageType;
(function (PackageType) {
    PackageType["BASE"] = "BASE";
    PackageType["ADDON"] = "ADDON";
    PackageType["INTEGERATION"] = "INTEGERATION";
    PackageType["OTHER"] = "OTHER";
})(PackageType || (PackageType = {}));
export var PackageType_index;
(function (PackageType_index) {
    PackageType_index[PackageType_index["BASE"] = 0] = "BASE";
    PackageType_index[PackageType_index["ADDON"] = 1] = "ADDON";
    PackageType_index[PackageType_index["INTEGERATION"] = 2] = "INTEGERATION";
    PackageType_index[PackageType_index["OTHER"] = 3] = "OTHER";
})(PackageType_index || (PackageType_index = {}));
export var State;
(function (State) {
    State["ACTIVE"] = "ACTIVE";
    State["PROMOTE"] = "PROMOTE";
    State["HIDE"] = "HIDE";
    State["TRIAL"] = "TRIAL";
})(State || (State = {}));
export var State_index;
(function (State_index) {
    State_index[State_index["ACTIVE"] = 0] = "ACTIVE";
    State_index[State_index["PROMOTE"] = 1] = "PROMOTE";
    State_index[State_index["HIDE"] = 2] = "HIDE";
    State_index[State_index["TRIAL"] = 3] = "TRIAL";
})(State_index || (State_index = {}));
//TrialStageBanner represents banners for different stages of trial
export var TrialStageBanner;
(function (TrialStageBanner) {
    TrialStageBanner["TRIAL_STAGE_BANNER_UNKNOWN"] = "TRIAL_STAGE_BANNER_UNKNOWN";
    TrialStageBanner["TRIAL_STAGE_BANNER_AVAILABLE"] = "TRIAL_STAGE_BANNER_AVAILABLE";
    TrialStageBanner["TRIAL_STAGE_BANNER_ABOUT_TO_EXPIRE"] = "TRIAL_STAGE_BANNER_ABOUT_TO_EXPIRE";
    TrialStageBanner["TRIAL_STAGE_BANNER_EXPIRED"] = "TRIAL_STAGE_BANNER_EXPIRED";
})(TrialStageBanner || (TrialStageBanner = {}));
export var TrialStageBanner_index;
(function (TrialStageBanner_index) {
    TrialStageBanner_index[TrialStageBanner_index["TRIAL_STAGE_BANNER_UNKNOWN"] = 0] = "TRIAL_STAGE_BANNER_UNKNOWN";
    TrialStageBanner_index[TrialStageBanner_index["TRIAL_STAGE_BANNER_AVAILABLE"] = 1] = "TRIAL_STAGE_BANNER_AVAILABLE";
    TrialStageBanner_index[TrialStageBanner_index["TRIAL_STAGE_BANNER_ABOUT_TO_EXPIRE"] = 2] = "TRIAL_STAGE_BANNER_ABOUT_TO_EXPIRE";
    TrialStageBanner_index[TrialStageBanner_index["TRIAL_STAGE_BANNER_EXPIRED"] = 3] = "TRIAL_STAGE_BANNER_EXPIRED";
})(TrialStageBanner_index || (TrialStageBanner_index = {}));
// TrialTask represents different tasks for free trials
export var TrialTask;
(function (TrialTask) {
    TrialTask["TRIAL_TASK_UNKNOWN"] = "TRIAL_TASK_UNKNOWN";
    TrialTask["TRIAL_TASK_ONLINE_SCHEDULING_SITE_LINK"] = "TRIAL_TASK_ONLINE_SCHEDULING_SITE_LINK";
    TrialTask["TRIAL_TASK_ONLINE_SCHEDULING_SETUP"] = "TRIAL_TASK_ONLINE_SCHEDULING_SETUP";
    TrialTask["TRIAL_TASK_ONLINE_SCHEDULING_FEATURES"] = "TRIAL_TASK_ONLINE_SCHEDULING_FEATURES";
    TrialTask["TRIAL_TASK_DIGITAL_FORMS_CREATE_FORM"] = "TRIAL_TASK_DIGITAL_FORMS_CREATE_FORM";
    TrialTask["TRIAL_TASK_DIGITAL_FORMS_SEND_FORM"] = "TRIAL_TASK_DIGITAL_FORMS_SEND_FORM";
    TrialTask["TRIAL_TASK_DIGITAL_FORMS_VIEW_AND_SYNC_FORM_SUBMISSION"] = "TRIAL_TASK_DIGITAL_FORMS_VIEW_AND_SYNC_FORM_SUBMISSION";
    TrialTask["TRIAL_TASK_TEXT_CONNECT_SETUP"] = "TRIAL_TASK_TEXT_CONNECT_SETUP";
    TrialTask["TRIAL_TASK_TEXT_CONNECT_FEATURES"] = "TRIAL_TASK_TEXT_CONNECT_FEATURES";
})(TrialTask || (TrialTask = {}));
export var TrialTask_index;
(function (TrialTask_index) {
    TrialTask_index[TrialTask_index["TRIAL_TASK_UNKNOWN"] = 0] = "TRIAL_TASK_UNKNOWN";
    TrialTask_index[TrialTask_index["TRIAL_TASK_ONLINE_SCHEDULING_SITE_LINK"] = 1] = "TRIAL_TASK_ONLINE_SCHEDULING_SITE_LINK";
    TrialTask_index[TrialTask_index["TRIAL_TASK_ONLINE_SCHEDULING_SETUP"] = 2] = "TRIAL_TASK_ONLINE_SCHEDULING_SETUP";
    TrialTask_index[TrialTask_index["TRIAL_TASK_ONLINE_SCHEDULING_FEATURES"] = 3] = "TRIAL_TASK_ONLINE_SCHEDULING_FEATURES";
    TrialTask_index[TrialTask_index["TRIAL_TASK_DIGITAL_FORMS_CREATE_FORM"] = 4] = "TRIAL_TASK_DIGITAL_FORMS_CREATE_FORM";
    TrialTask_index[TrialTask_index["TRIAL_TASK_DIGITAL_FORMS_SEND_FORM"] = 5] = "TRIAL_TASK_DIGITAL_FORMS_SEND_FORM";
    TrialTask_index[TrialTask_index["TRIAL_TASK_DIGITAL_FORMS_VIEW_AND_SYNC_FORM_SUBMISSION"] = 6] = "TRIAL_TASK_DIGITAL_FORMS_VIEW_AND_SYNC_FORM_SUBMISSION";
    TrialTask_index[TrialTask_index["TRIAL_TASK_TEXT_CONNECT_SETUP"] = 7] = "TRIAL_TASK_TEXT_CONNECT_SETUP";
    TrialTask_index[TrialTask_index["TRIAL_TASK_TEXT_CONNECT_FEATURES"] = 8] = "TRIAL_TASK_TEXT_CONNECT_FEATURES";
})(TrialTask_index || (TrialTask_index = {}));
// TrialStatus represents different status of free trials 
export var TrialStatus;
(function (TrialStatus) {
    TrialStatus["FREE_TRIAL_UNSPECIFIED"] = "FREE_TRIAL_UNSPECIFIED";
    TrialStatus["FREE_TRIAL_ACTIVE"] = "FREE_TRIAL_ACTIVE";
    TrialStatus["FREE_TRIAL_ABOUT_TO_EXPIRE"] = "FREE_TRIAL_ABOUT_TO_EXPIRE";
    TrialStatus["FREE_TRIAL_EXPIRED"] = "FREE_TRIAL_EXPIRED";
})(TrialStatus || (TrialStatus = {}));
export var TrialStatus_index;
(function (TrialStatus_index) {
    TrialStatus_index[TrialStatus_index["FREE_TRIAL_UNSPECIFIED"] = 0] = "FREE_TRIAL_UNSPECIFIED";
    TrialStatus_index[TrialStatus_index["FREE_TRIAL_ACTIVE"] = 1] = "FREE_TRIAL_ACTIVE";
    TrialStatus_index[TrialStatus_index["FREE_TRIAL_ABOUT_TO_EXPIRE"] = 2] = "FREE_TRIAL_ABOUT_TO_EXPIRE";
    TrialStatus_index[TrialStatus_index["FREE_TRIAL_EXPIRED"] = 3] = "FREE_TRIAL_EXPIRED";
})(TrialStatus_index || (TrialStatus_index = {}));
export var Action;
(function (Action) {
    Action["ACTION_UNKNOWN"] = "ACTION_UNKNOWN";
    Action["ACTION_REMIND_AFTER_3_DAYS"] = "ACTION_REMIND_AFTER_3_DAYS";
    Action["ACTION_NEVER_SHOW_AGAIN"] = "ACTION_NEVER_SHOW_AGAIN";
})(Action || (Action = {}));
export var Action_index;
(function (Action_index) {
    Action_index[Action_index["ACTION_UNKNOWN"] = 0] = "ACTION_UNKNOWN";
    Action_index[Action_index["ACTION_REMIND_AFTER_3_DAYS"] = 1] = "ACTION_REMIND_AFTER_3_DAYS";
    Action_index[Action_index["ACTION_NEVER_SHOW_AGAIN"] = 2] = "ACTION_NEVER_SHOW_AGAIN";
})(Action_index || (Action_index = {}));
export var Source;
(function (Source) {
    Source["SOURCE_UNKNOWN"] = "SOURCE_UNKNOWN";
    Source["SOURCE_APPOINTMENT_TEASER_BANNER"] = "SOURCE_APPOINTMENT_TEASER_BANNER";
    Source["SOURCE_DASHBOARD_TEASER_BANNER"] = "SOURCE_DASHBOARD_TEASER_BANNER";
    Source["SOURCE_MESSAGING_TEASER_BANNER"] = "SOURCE_MESSAGING_TEASER_BANNER";
})(Source || (Source = {}));
export var Source_index;
(function (Source_index) {
    Source_index[Source_index["SOURCE_UNKNOWN"] = 0] = "SOURCE_UNKNOWN";
    Source_index[Source_index["SOURCE_APPOINTMENT_TEASER_BANNER"] = 1] = "SOURCE_APPOINTMENT_TEASER_BANNER";
    Source_index[Source_index["SOURCE_DASHBOARD_TEASER_BANNER"] = 2] = "SOURCE_DASHBOARD_TEASER_BANNER";
    Source_index[Source_index["SOURCE_MESSAGING_TEASER_BANNER"] = 3] = "SOURCE_MESSAGING_TEASER_BANNER";
})(Source_index || (Source_index = {}));
